import { Injectable } from '@angular/core';
import { subjectFromObs } from 'core/rx-js';
import { RoleRemoteControllerService } from './remote-controllers';

@Injectable({
  providedIn: 'root'
})
export class RemoteConfigService {

  readonly rolesSubject = subjectFromObs({
    initialValue: [],
    observable: this._roleRemoteControllerService.getMany(),
  })

  constructor(
    private readonly _roleRemoteControllerService: RoleRemoteControllerService
  ) {

  }



}
